module.exports = __webpack_public_path__ + "static/media/upload.e6eed8b8.svg";